/* NOOR Theme JavaScript — Pendant Spin, Scroll Reveal, Mobile Menu */
(function() {
  'use strict';

  function initPendantSpins() {
    document.querySelectorAll('[data-pendant-spin]').forEach(function(spin) {
      var dots = spin.querySelectorAll('[data-spin-dot]');
      var indicator = spin.querySelector('[data-spin-indicator]');
      var isFlipped = false;
      var autoInterval = null;

      function flip() {
        isFlipped = !isFlipped;
        if (isFlipped) {
          spin.classList.add('is-flipped');
          if (indicator) indicator.textContent = 'Back';
        } else {
          spin.classList.remove('is-flipped');
          if (indicator) indicator.textContent = 'Front';
        }
        dots.forEach(function(d) { d.classList.remove('is-active'); });
        var activeDot = spin.querySelector('[data-spin-dot="' + (isFlipped ? 'back' : 'front') + '"]');
        if (activeDot) activeDot.classList.add('is-active');
      }

      function startAuto() { stopAuto(); autoInterval = setInterval(flip, 3000); }
      function stopAuto() { if (autoInterval) { clearInterval(autoInterval); autoInterval = null; } }

      spin.addEventListener('click', function(e) {
        if (e.target.closest('[data-spin-dot]')) return;
        stopAuto(); flip(); startAuto();
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.stopPropagation(); stopAuto();
          var side = dot.getAttribute('data-spin-dot');
          if (side === 'back' && !isFlipped) flip();
          else if (side === 'front' && isFlipped) flip();
          startAuto();
        });
      });

      spin.addEventListener('mouseenter', stopAuto);
      spin.addEventListener('mouseleave', startAuto);
      startAuto();
    });
  }

  function initScrollReveal() {
    var reveals = document.querySelectorAll('.noor-reveal');
    if (!reveals.length) return;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
      reveals.forEach(function(el) { observer.observe(el); });
    } else {
      reveals.forEach(function(el) { el.classList.add('is-visible'); });
    }
  }

  function initMobileMenu() {
    var toggle = document.getElementById('noor-mobile-toggle');
    var menu = document.getElementById('noor-mobile-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function() {
      var isOpen = menu.classList.contains('is-open');
      if (isOpen) { menu.classList.remove('is-open'); document.body.style.overflow = ''; }
      else { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() { menu.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initPendantSpins();
    initScrollReveal();
    initMobileMenu();
  });
})();
